
import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import SelectComponent from '@/components/shared/Select.vue';
import TextField from '@/components/shared/TextField.vue';

const namespace: string = 'inquiryForm';

@Component<InquiryRequestFilters>({
	components: {
		SelectComponent,
		TextField
	}
})
export default class InquiryRequestFilters extends Vue {
	@Action('setInquiryFormFilters', { namespace }) private setInquiryFormFilters!: (filters: InquiryFormFilters) => void;
	@Getter('getInquiryFormFilters', { namespace }) private filters!: InquiryFormFilters;

	private mutableFilters: InquiryFormFilters = {
		orderBy: 'created_at',
		quoted: undefined,
		search: ''
	};

	private created(): void {
		this.mutableFilters = { ...this.filters };
	}

	/**
	 * Emit active filters (excluding empty/null values) to the parent
	 *
	 * @param {boolean} showLoading
	 * @return {void}
	 */
	private emitFilters(showLoading: boolean): void {
		this.setInquiryFormFilters({ ...this.mutableFilters });
		this.$emit('filters-changed', showLoading);
	}
}
